import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
export const AutoFocusCatcher = () => {
    // this component avoid autoFocus on input element
    return (_jsx(Button, { autoFocus: true, a11yLabel: "button", variant: "link", sx: {
            position: 'absolute',
            width: 1,
            height: 1,
            padding: 0,
            margin: 0,
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            whiteSpace: 'nowrap',
            border: 0,
            minWidth: 0,
            minHeight: 0,
        } }));
};
//# sourceMappingURL=AutoFocusCatcher.js.map